import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design:{},
    runningList: [],
    noTakeList: [],
    endList: [],
    auditList:[],
    diagramMode: 'design',
    systemList:[],
    systemMenu:{
      loading:false,
      list:[]
    },
  },

  approverTitle:"todo",
  tabBar:"approval",
  mutations: {
    selectedNode(state, val) {
      state.selectedNode = val
    },
    loadForm(state, val){
      state.design = val
    },
    setIsEdit(state, val){
      state.isEdit = val
    },
    setMenuLoading(state) {
      state.systemMenu.loading = !state.systemMenu.loading
    },
    setMenu(state,menu) {
      state.systemMenu.list = menu
    },
    //设置系统列表
    setSystem(state,list) {
      state.systemList = list
    },
  },
  getters: {},
  actions: {},
  modules: {}
})
